import React, { ReactElement, useEffect, useState } from 'react';

interface MarkerImageProps {
  src?: string;
  alt: string;
}

export default function MarkerImage({ src, alt }: MarkerImageProps): ReactElement | null {
  const [imageFound, setImageFound] = useState(false);
  useEffect(() => {
    if (src) {
      const loadListener = () => setImageFound(true);
      const img = new Image();
      img.addEventListener('load', loadListener);
      img.src = src;
      return () => {
        img.removeEventListener('load', loadListener);
      };
    }
  }, [src]);
  if (imageFound) {
    return <img src={src} alt={alt} />;
  }
  return null;
}
